import { FirebaseApp, initializeApp, getApps } from "firebase/app";
import { firebaseClientConfig } from "config/firebase";
import {
  logEvent,
  EventNameString,
  getAnalytics,
  EventParams,
  AnalyticsCallOptions,
} from "firebase/analytics";

// Utils
import { sentryErrorLog } from "./sentryLog";
import { FIREBASE_EVENT_PROPERTIES } from "constants/constants";
import { getRefrenceParams } from "app-head";

let _fbApp: FirebaseApp | undefined = undefined;

if (typeof window !== "undefined" && getApps().length <= 0) {
  _fbApp = initializeApp(firebaseClientConfig, {
    automaticDataCollectionEnabled: true,
  });
}

export const fbApp = _fbApp;

export const trackEvent = (
  eventName: EventNameString | string,
  eventParams: EventParams = {},
  options?: AnalyticsCallOptions
) => {
  try {
    const refParams = getRefrenceParams();
    (window as any).rudderanalytics.track(eventName, {
      ...eventParams,
      dapp: "hedera",
      ...refParams,
    });
  } catch (e) {
    sentryErrorLog(e);
  }

  try {
    const analytics = getAnalytics(_fbApp);
    logEvent(analytics, eventName, { ...eventParams }, options);

    const events = (window as any).dataLayer;
    (window as any).dataLayer[events.length - 1] = {
      ...events[events.length - 1],
      ...eventParams,
      eventName: eventName,
    };
    (window as any).dataLayer?.push({
      event: eventName,
      ...eventParams,
    });
  } catch (e) {
    sentryErrorLog(e);
  }
};

const getWalletData = () => {
  return JSON.parse(
    window.localStorage.getItem("hashConnectData/mainnet") ||
      '{"pairedAccounts":[],"pairedWalletData":{"name":""}}'
  );
};

export const firebaseEvents = (eventParams: any) => {
  try {
    const logData = { ...eventParams };
    const analytics = getAnalytics(_fbApp);
    const eventName = logData.event_name;
    if (logData[FIREBASE_EVENT_PROPERTIES.WALLET_NAME] === null) {
      logData[FIREBASE_EVENT_PROPERTIES.WALLET_NAME] =
        getWalletData().pairedWalletData.name;
    }
    if (logData[FIREBASE_EVENT_PROPERTIES.WALLET_ADDRESS] === null) {
      logData[FIREBASE_EVENT_PROPERTIES.WALLET_ADDRESS] =
        getWalletData().pairedAccounts[0];
    }
    delete logData.event_name;
    logEvent(analytics, eventName, logData);

    const events = (window as any).dataLayer;
    (window as any).dataLayer[events.length - 1] = {
      ...events[events.length - 1],
      ...logData,
      eventName: eventName,
    };
    (window as any).dataLayer?.push({
      event: eventName,
      ...logData,
    });
  } catch (e) {
    // TODO Replace with sentry
    // eslint-disable-next-line no-console
    console.log("Error Logging Firebase ", e);
    // sentryErrorLog(e);
  }
};
